import React from 'react';
import { Card, Breadcrumb } from 'antd';
import { onGet, api } from '../../../../core/api3';
import { getUrlParam } from '../../../../utils/commonUtils';
import HuobiInvestmentRecordCard from './HuobiInvestmentRecordCard';
import ReactEcharts from 'echarts-for-react';
import echarts from 'echarts';
import moment from 'moment';

class HuobiDetailPage extends React.Component {

    constructor() {
        super();
        this.state = {
            profitLosss: []
        }
        this.loadData = this.loadData.bind(this);
        this.getOption = this.getOption.bind(this);
    }

    componentDidMount() {
        this.loadData();
    }

    loadData() {
        let symbol = getUrlParam(this.props.location.search, 'symbol');
        onGet(api.listHuobiInvestmentProfitLoss.url, api.listHuobiInvestmentProfitLoss.params(symbol)).then(response => {
            if (response === undefined) {
                return;
            }
            response.forEach(profitLoss => {
                profitLoss.createTime = moment(profitLoss.createTime * 1000).format('YYYY-MM-DD');
            });
            this.setState({ profitLosss: response });
        });
    }

    getOption() {
        let date = [];
        this.state.profitLosss.forEach(profitLoss => {
            date.push(profitLoss.createTime);
        });
        let data = [];
        this.state.profitLosss.forEach(profitLoss => {
            data.push(profitLoss.profitLoss);
        });
        let option = {
            tooltip: {
                trigger: 'axis',
                position: function (pt) {
                    return [pt[0], '10%'];
                }
            },
            toolbox: {
                feature: {
                    dataZoom: {
                        yAxisIndex: 'none'
                    },
                    restore: {},
                    saveAsImage: {}
                }
            },
            xAxis: {
                type: 'category',
                boundaryGap: false,
                data: date
            },
            yAxis: {
                type: 'value',
                boundaryGap: [0, '100%']
            },
            dataZoom: [{
                type: 'inside',
                start: 0,
                end: 100
            }, {
                start: 0,
                end: 100,
                handleIcon: 'M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4v1.3h1.3v-1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z',
                handleSize: '100%',
                handleStyle: {
                    color: '#fff',
                    shadowBlur: 3,
                    shadowColor: 'rgba(0, 0, 0, 0.6)',
                    shadowOffsetX: 2,
                    shadowOffsetY: 2
                }
            }],
            series: [
                {
                    name: '累计收益',
                    type: 'line',
                    smooth: true,
                    symbol: 'none',
                    sampling: 'average',
                    itemStyle: {
                        color: 'rgb(255, 70, 131)'
                    },
                    areaStyle: {
                        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                            offset: 0,
                            color: 'rgb(255, 158, 68)'
                        }, {
                            offset: 1,
                            color: 'rgb(255, 70, 131)'
                        }])
                    },
                    data: data
                }
            ]
        };
        return option;
    }

    render() {
        return (
            <div>
                <Breadcrumb className="breadcrumb">
                    <Breadcrumb.Item><a href="#/index">首页</a></Breadcrumb.Item>
                    <Breadcrumb.Item><a href="#/coin/huobi">火币现货</a></Breadcrumb.Item>
                    <Breadcrumb.Item>火币现货详情</Breadcrumb.Item>
                </Breadcrumb>
                <div className="content2">
                    <Card title="收益走势图" bordered={false} >
                        <ReactEcharts
                            option={this.getOption()}
                            notMerge={true}
                            lazyUpdate={true}
                            style={{ width: '100%', height: '500px' }}
                        />
                    </Card>
                </div>
                <div className="content2">
                    <HuobiInvestmentRecordCard symbol={getUrlParam(this.props.location.search, 'symbol')} location={this.props.location} />
                </div>
            </div>
        );
    }

}

export default HuobiDetailPage;


// WEBPACK FOOTER //
// ./src/page/jsx/coin/huobi/HuobiDetailPage.jsx